import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles(({ theme }) => {
  const { spacing, breakpoints } = theme;

  return {
    container: { flex: 1, overflow: "hidden" },
    destinationLabel: {
      flex: 1
    },
    destinationContainer: {
      maxWidth: "100%",
      minWidth: "0"
    },
    destinationIcon: {
      flexShrink: 0
    },
    hideXs: {
      display: "none",
      [breakpoints.up("sm")]: {
        display: "block"
      }
    },
    progress: { alignSelf: "center" },
    price: {
      marginLeft: spacing(2),
      [breakpoints.up("md")]: {
        marginLeft: spacing(3)
      }
    }
  };
});
